import { render, staticRenderFns } from "./choice_echo.vue?vue&type=template&id=95fa1e82&scoped=true&"
import script from "./choice_echo.vue?vue&type=script&lang=js&"
export * from "./choice_echo.vue?vue&type=script&lang=js&"
import style0 from "./choice_echo.vue?vue&type=style&index=0&id=95fa1e82&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95fa1e82",
  null
  
)

export default component.exports